// store/skillSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LinkPdf } from '../interfaces/store';
import { testLinks } from '../interfaces/const';


const initialState: LinkPdf[] = [];
// const initialState: LinkPdf[] = testLinks;

const linkSlice = createSlice({
  name: 'links',
  initialState,
  reducers: {
    addLink(state, action: PayloadAction<LinkPdf>) {
        const index = state.findIndex(e => e.id === action.payload.id);
        if (index !== -1) {
            state[index] = action.payload;
        } else {
            state.push(action.payload);
        }
    },
    updateLink(state, action: PayloadAction<LinkPdf>) {
      const index = state.findIndex(s => s.id === action.payload.id);
      if (index !== -1) state[index] = action.payload;
    },
    removeLink(state, action: PayloadAction<string>) {
      const index = state.map(e => e.id).indexOf(action.payload);
      const item = state[index]

      item.name = ''
      item.status = 'delete'
      state[index] = item
      return state
    },
  },
});

export const { addLink, updateLink, removeLink } = linkSlice.actions;
export default linkSlice.reducer;
